import { Box, CircularProgress, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Import check circle icon

interface LoadingOverlayProps {
  isProcessing: boolean; // Whether the payment is being processed
  isSuccess: boolean; // Whether the payment was successful
}

const PaymentProcessingLoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isProcessing,
  isSuccess
}) => {
  if (!isProcessing && !isSuccess) return null; // If neither processing nor success, return null

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.7)', // Semi-transparent overlay
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1300, // Ensure overlay is above other components
        textAlign: 'center',
        padding: 2
      }}
    >
      {isProcessing ? (
        <>
          <CircularProgress size={60} />
          <Typography variant="h6" sx={{ marginTop: 2 }}>
            Processing Payment...
          </Typography>
        </>
      ) : isSuccess ? (
        <>
          <CheckCircleIcon sx={{ color: 'green', fontSize: 60 }} />
          <Typography variant="h6" sx={{ marginTop: 2, color: 'green' }}>
            Payment Successful!
          </Typography>
        </>
      ) : null}
    </Box>
  );
};

export default PaymentProcessingLoadingOverlay;
